export default __webpack_public_path__ + "static/media/amsQuery-color.a87c17b9.svg";